import { makeJsonApiRequest } from '@base/axios'

// Base URL for field select option endpoints
const baseUrl = '/api/v2'

// Most field select option API calls share this base arg in order to construct the URL
interface BaseFieldSelectOptionArgs {
  tableId: string | number
  fieldId: string | number
}

// Inidividual arg interfaces extend the base

export interface FetchFieldSelectOptionsArgs extends BaseFieldSelectOptionArgs {}
export interface CreateFieldSelectOptionArgs extends BaseFieldSelectOptionArgs {
  label: string
}
export interface UpdateFieldSelectOptionArgs extends BaseFieldSelectOptionArgs {
  optionId: number
  label?: string
  position?: number
}
export interface DeleteFieldSelectOptionArgs extends BaseFieldSelectOptionArgs {
  optionId: number
}

// Fetch all select options for a field
export const fetchFieldSelectOptions = ({ tableId, fieldId }: FetchFieldSelectOptionsArgs) => {
  return makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields/${fieldId}/field_select_options`,
    method: 'get',
    requestId: `fetch-options-${tableId}-${fieldId}`,
  })
}

// Create a new field select option
export const createFieldSelectOption = ({ tableId, fieldId, label }: CreateFieldSelectOptionArgs) => {
  const requestData = {
    data: {
      type: 'field_select_options',
      attributes: { label },
    },
  }
  return makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields/${fieldId}/field_select_options`,
    method: 'post',
    data: requestData,
    requestId: `add-option-${tableId}-${fieldId}`,
  })
}

// Update an existing field select option (label and/or position)
export const updateFieldSelectOption = ({
  tableId,
  fieldId,
  optionId,
  label,
  position,
}: UpdateFieldSelectOptionArgs) => {
  const attributes: Record<string, any> = {}
  if (label !== undefined) attributes.label = label
  if (position !== undefined) attributes.position = position
  const requestData = {
    data: {
      id: String(optionId),
      type: 'field_select_options',
      attributes,
    },
  }
  return makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields/${fieldId}/field_select_options/${optionId}`,
    method: 'patch',
    data: requestData,
    requestId: `update-option-${tableId}-${fieldId}-${optionId}`,
  })
}

// Delete a field select option
export const deleteFieldSelectOption = ({ tableId, fieldId, optionId }: DeleteFieldSelectOptionArgs) => {
  return makeJsonApiRequest({
    url: `${baseUrl}/tables/${tableId}/fields/${fieldId}/field_select_options/${optionId}`,
    method: 'delete',
    requestId: `remove-option-${tableId}-${fieldId}-${optionId}`,
  })
}

export default {
  fetchFieldSelectOptions,
  createFieldSelectOption,
  updateFieldSelectOption,
  deleteFieldSelectOption,
}
